import { AfterContentInit, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Empreiteira } from "src/app/models/empreiteira.model";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { EmpreiteiraService } from "src/app/pages/cadastros/empreiteira/empreiteira.service";
import { OSService } from "src/app/services/os-service";
import { SpvService } from "src/app/services/spv.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { ImagemUtil } from "src/app/utils/Imagem.util";
import { Security } from "src/app/utils/security.util";
import { Util } from "src/app/utils/util.util";
import { APP_SETTINGS } from "src/environments/environment";
import Swal from "sweetalert2";
import { CommandResult } from "../../domain/commandResult";
import { FotoBase64ViewModel } from "../../domain/viewmodels.models";
import { FecharOSService } from "./fechar-os.service";
import { Photo } from "./photo.model";
import { UploadPhoto } from "./upload-photo.model";
import { IMAGENS_SATISFACAO } from "src/app/shareds/constantes";
import { CORES_STATUS_OS } from "src/app/shareds/constantes";

@Component({
  selector: "app-fechar-os",
  templateUrl: "./fechar-os.component.html",
  styleUrls: ["./fechar-os.component.scss"],
  providers: [EmpreiteiraService, OSService, SpvService],
})
export class FecharOsComponent implements OnInit, AfterContentInit {
  empreiteiras: Empreiteira[] = [];
  validacaoEmpreiteira = "";
  resultadosPesquisa: any[];
  nenhumResultado = false;

  // Cores representativas para cada status de uma OS.
  // [Aberta: azul, NaoRealizada:  verm, Fechada:  verde, Cancelada:  laranja, Executada: ]

  bgStatus: string[] = CORES_STATUS_OS;

  spvCompleto: any = null; // representa SS ou PT
  osCompleta: any = null;

  isProcessing = false;
  isSearchById = false;

  validacaoQuantidade = false;

  uploadPhotos: UploadPhoto[] = [];

  files: File[] = []; // armazena os arquivo de fotos
  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewPhotoSelecionada: Photo; // dataUrl (base 64) da foto clicada
  photoForm: FormGroup;
  isLoadingRegistroFotografico: boolean = false;

  possiveisColaboradoresListaGrid: any[] = [];
  possiveisMateriaisListaGrid: any[] = [];
  public imagens_satisfacao: string[] = IMAGENS_SATISFACAO;

  showModalLogAvaliacao: boolean = null;

  form: FormGroup = this.formBuilder.group(
    {
      osid: [""],
      empreiteiraId: ["", [Validators.required]],
      importadasMobilidade: [false],
      dataEmissaoInicial: [""],
      dataEmissaoFinal: [""],
    },
    { validators: this.dateLessThan("dataEmissaoInicial", "dataEmissaoFinal") },
  );

  validacoes: {
    servicoRealizado: string;
    observacaoExecucao: string;
    observacaoAvaliacao: string;
    dataHoraInicioExec: string;
    dataHoraFimExec: string;
    datasColaboradoresOK: boolean; //?
    cliente: string;
    satisfeito: string;
    reset(): void;
    valid(): boolean;
  } = {
      servicoRealizado: "",
      observacaoExecucao: "",
      observacaoAvaliacao: "",
      dataHoraInicioExec: "",
      dataHoraFimExec: "",
      datasColaboradoresOK: true, //?
      cliente: "",
      satisfeito: "",
      reset(): void {
        this.servicoRealizado = "";
        this.observacaoExecucao = "";
        this.observacaoAvaliacao = "";
        this.dataHoraInicioExec = "";
        this.dataHoraFimExec = "";
        this.datasColaboradoresOK = true; //?
        this.cliente = "";
        this.satisfeito = "";
      },
      valid(): boolean {
        return (
          this.servicoRealizado === "" &&
          this.dataHoraInicioExec === "" &&
          this.dataHoraFimExec === "" &&
          this.datasColaboradoresOK == true &&
          this.observacaoExecucao === "" &&
          this.observacaoAvaliacao === "" &&
          this.cliente === "" &&
          this.satisfeito === ""
        );
      },
    };

  autorizacoes: UsuarioAutorizacoes;
  autorizacaoAdicionarFoto: boolean;

  previewsPhotosAntes: Photo[] = []; // armazena as photos em base 64 para exibição
  filesAntes: File[] = [];
  filesAntesAdicionados: File[] = [];
  isRemoveProcessing: boolean;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;
  validacaoDatas = "";

  @Input() titulo: string = "Fechar OS";
  @Input() tipoAcaoOS: number = 1; // 1 - Fechar OS, 2 - Visto Execucao ou 3 - ValidarOS

  constructor(
    private empreiteiraService: EmpreiteiraService,
    private osservice: OSService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private fechamentoOSService: FecharOSService,
    private osService: OSService,
  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("fechar-os");
    this.autorizacaoAdicionarFoto =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "ss-pt-programar-servico",
        "adicionar-fotos-antes",
      );
  }

  ngOnInit() {
    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteiras = response;
      if (this.empreiteiras.length == 1) {
        this.form.get("empreiteiraId").setValue(this.empreiteiras[0].id);
        this.buscar();
      }
    });

    this.resetPhotoForm();
  }

  dateLessThan(initial: string, final: string) {
    return (formGroup: FormGroup) => {
      const initialControl = formGroup.controls[initial];
      const finalControl = formGroup.controls[final];

      if (
        initialControl.value &&
        finalControl.value &&
        initialControl.value > finalControl.value
      ) {
        finalControl.setErrors({ dateLessThan: true });
      } else {
        finalControl.setErrors(null);
      }
    };
  }

  reset() {
    this.validacaoEmpreiteira = "";
    this.validacaoDatas = "";

    this.resultadosPesquisa = [];
    this.nenhumResultado = false;

    this.isProcessing = false;
    this.validacoes.reset();

    this.uploadPhotos = [];

    this.files = [];
    this.resetPhotoForm();
    this.previewsPhotos = [];
    this.previewPhotoSelecionada = null;
    this.previewsPhotosAntes = [];
    this.filesAntes = [];
    this.filesAntesAdicionados = [];
  }

  limparParametroOS() {
    this.form.get("osid").setValue("");
  }

  resetPhotoForm() {
    this.photoForm = this.formBuilder.group({
      photo: [""],
      photoAntes: [""],
    });
  }

  buscar() {
    this.resultadosPesquisa = [];
    console.log("buscando...");

    if (this.validaDados()) {
      const parametros = {
        oSId: Number(this.form.get("osid").value),
        empreiteiraId: this.form.get("empreiteiraId").value,
        importadasMobilidade: this.form.get("importadasMobilidade").value,
        dataEmissaoInicial: this.form.get("dataEmissaoInicial").value,
        dataEmissaoFinal: this.form.get("dataEmissaoFinal").value,
        tipoAcaoOS: this.tipoAcaoOS,
      };
      this.isProcessing = true;
      this.nenhumResultado = false;

      this.osservice.getOSsParaFechar(parametros).subscribe(
        (response) => {
          this.resultadosPesquisa = response;
          if (
            !this.resultadosPesquisa ||
            this.resultadosPesquisa.length === 0
          ) {
            this.nenhumResultado = true;
          }
          this.isProcessing = false;
        },
        (err: any) => {
          this.showError(err);
          this.reset();
        },
      );
    }
  }

  validaDados() {
    this.validacaoEmpreiteira = "";
    this.validacaoDatas = "";

    if (this.form.get("empreiteiraId").value === "") {
      this.validacaoEmpreiteira = "Selecione uma Empreiteira";
      return false;
    }

    if (this.isDatasEmissaoAmbasVaziasOuPreenchidas() == false) {
      this.validacaoDatas =
        "Informe as datas de emissão ou deixe ambas em branco";
      return false;
    }
    return this.form.valid;
  }

  limparDataEmissaoInicial(): void {
    this.form.get("dataEmissaoInicial").setValue("");
    this.isDatasEmissaoAmbasVaziasOuPreenchidas();
  }

  limparDataEmissaoFinal(): void {
    this.form.get("dataEmissaoFinal").setValue("");
    this.isDatasEmissaoAmbasVaziasOuPreenchidas();
  }

  isDatasEmissaoAmbasVaziasOuPreenchidas(): boolean {
    if (
      (this.form.get("dataEmissaoInicial").value === "" &&
        this.form.get("dataEmissaoFinal").value === "") ||
      (this.form.get("dataEmissaoInicial").value !== "" &&
        this.form.get("dataEmissaoFinal").value !== "")
    ) {
      this.validacaoDatas = "";
      return true;
    } else {
      return false;
    }
  }

  validaDadosRealizacao() {
   
    const servicoRealizado = (document.getElementById("servicoRealizado") as HTMLInputElement).value;
    const dataHoraInicioExec = (document.getElementById("dataHoraInicioExec") as HTMLInputElement).value;
    const dataHoraFimExec = (document.getElementById("dataHoraFimExec") as HTMLInputElement).value;
    const observacaoExecucao = this.tipoAcaoOS == 1 ? (document.getElementById("observacaoExecucao") as HTMLInputElement).value : "";
    const observacaoAvaliacao = this.tipoAcaoOS == 3 ? (document.getElementById("observacaoAvaliacao") as HTMLInputElement).value : "";
    const cliente = this.tipoAcaoOS == 3 ? (document.getElementById("cliente") as HTMLInputElement).value : "";
    const satisfeito = this.tipoAcaoOS == 3 ? (document.getElementById("satisfeito") as HTMLSelectElement) : null;
   
    if (servicoRealizado !== "") { this.validacoes.servicoRealizado = "";   }
    if (dataHoraInicioExec !== "") { this.validacoes.dataHoraInicioExec = "";}
    if (dataHoraFimExec !== "") { this.validacoes.dataHoraFimExec = ""; }
    if (observacaoExecucao !== "") {this.validacoes.observacaoExecucao = "";  }
    if (observacaoAvaliacao !== "") {this.validacoes.observacaoAvaliacao = ""; }
    if (cliente != "") { this.validacoes.cliente = ""; }
    if (satisfeito != null && satisfeito.selectedIndex != 0) { this.validacoes.satisfeito = ""; }
  }

  /*
  StatusFechamentoOS
    Aberta = 1,
    NaoRealizada = 2,
    Fechada = 3, 
    Cancelada = 4,
    Executada = 5, 
    Reprovada = 6,
    VistoExecucao = 7 
  */

  submit(c: any, statusFechamentoOS: number) {
    this.validacoes.reset();

    const servicoRealizado = (document.getElementById("servicoRealizado") as HTMLInputElement).value;
    const dataHoraInicioExec = (document.getElementById("dataHoraInicioExec") as HTMLInputElement).value;
    const dataHoraFimExec = (document.getElementById("dataHoraFimExec") as HTMLInputElement).value;

  
    if (this.tipoAcaoOS == 2) {
      if (servicoRealizado === "") {this.validacoes.servicoRealizado = "O Serviço Realizado deve ser informado";}
      if (dataHoraInicioExec === "") {this.validacoes.dataHoraInicioExec ="Informe a Data Hora Inicio da Execução"; }
      if (dataHoraFimExec === "") {this.validacoes.dataHoraFimExec = "Informe a Data Hora Fim da Execução";  }
      document.getElementById("dataHoraInicioExec").focus();
    }

    if (this.tipoAcaoOS == 1) {
      const observacaoExecucao = ( document.getElementById("observacaoExecucao") as HTMLInputElement ).value;
      if (observacaoExecucao === "") {this.validacoes.observacaoExecucao = "A observação execucao é obrigatória"; }
    }

    if (this.tipoAcaoOS == 3) {
      const observacaoAvaliacao = ( document.getElementById("observacaoAvaliacao") as HTMLInputElement ).value;
      if (observacaoAvaliacao === "") { this.validacoes.observacaoAvaliacao = "A observação sobre a avaliação é obrigatória";  }
    }

    const cliente = this.tipoAcaoOS == 3 ? (document.getElementById("cliente") as HTMLInputElement).value : "";
    const satisfeito = this.tipoAcaoOS == 3  ? (document.getElementById("satisfeito") as HTMLSelectElement) : null;

    if (this.tipoAcaoOS == 3  && this.osCompleta.codigoExportacao == null) {
      if (cliente === "") {this.validacoes.cliente = "Informe o cliente"; }
      if (satisfeito != null && satisfeito.selectedIndex === 0) {this.validacoes.satisfeito = "Selecione uma avaliação"; }
    }

    const now = new Date();
    this.uploadPhotos = [];

    let count = 0;
    if (this.files.length > 0) {
      for (const f of this.files) {
        count++;
        this.uploadPhotos.push({
          id: 0,
          arquivoNomeOriginal: f.name,
          arquivoNome: Util.getArquivoNome(this.osCompleta.osId, count),
          osFechamentoId: this.osCompleta.osFechamentoId,
          spvId: null,
          atividadeId: null,
        });
      }
    }

    if (this.filesAntesAdicionados.length > 0) {
      for (const f of this.filesAntesAdicionados) {
        count++;
        this.uploadPhotos.push({
          id: 0,
          arquivoNomeOriginal: f.name,
          arquivoNome: Util.getArquivoNome(this.osCompleta.osId, count),
          osFechamentoId: null,
          spvId: this.osCompleta.spvCompleto.spvId,
          atividadeId: null,
        });
      }
    }

    if (this.validacoes.valid()) {
      this.isProcessing = true;

      if (statusFechamentoOS == 99) {
      if (this.tipoAcaoOS == 1) statusFechamentoOS = 3; // Fechada
      if (this.tipoAcaoOS == 2) statusFechamentoOS = 7; // VistoExecucao = 7,
      if (this.tipoAcaoOS == 3) statusFechamentoOS = 8; // OSValidada = 8
      }

      const osFechamento = {
        id:
          this.osCompleta.osFechamentoId == null
            ? 0
            : this.osCompleta.osFechamentoId,
        servicoRealizado,
        dataHoraInicioExec,
        dataHoraFimExec,
        oSId: this.osCompleta.osId,
        tipoOSFilha: this.osCompleta.tipoOSFilha,
        dataHoraFechamento: now,
        encarregadoResponsavelId:
          this.osCompleta.spvCompleto.encarregadoResponsavelId,
        engenheiroResponsavelId:
          this.osCompleta.spvCompleto.engenheiroResponsavelId,
        oSsFechamentoIrregularidade: this.osCompleta.irregularidades,
        movsOrdemFuncionario: this.osCompleta.spvCompleto.colaboradores,
        uploadPhotos: this.uploadPhotos,
        osFechamentoMovOrdemMateriais: this.osCompleta.materiaisUsado,
        colaboradores: this.osCompleta.spvCompleto.colaboradores.map((t) => {
          return {
            oSId: this.osCompleta.osId,
            spvAprovadoId: this.osCompleta.spvCompleto.spvAprovadoId,
            ptId: this.osCompleta.spvCompleto.ptId,
            funcionarioId: t.id,
          };
        }),
        status: statusFechamentoOS,
        usuarioFechamentoId: Security.getUser().id,
        atualizaMaterialValor: APP_SETTINGS.AtualizaMaterialValor,
        codigoExportacao: this.osCompleta.codigoExportacao,
        cliente: this.osCompleta.cliente,
        matricula: this.osCompleta.matricula,
        satisfeito: this.osCompleta.satisfeito,
        setor: this.osCompleta.setor,
        observacaoExecucao: this.osCompleta.observacaoExecucao,
        observacaoAvaliacao: this.osCompleta.observacaoAvaliacao,
        tipoAcaoOS: this.tipoAcaoOS,
      };

      this.fechamentoOSService.fecharOS(osFechamento).subscribe(
        (response) => {
          if (response.success == false) {
            this.toastr.error(`${response.message} - A OS não foi fechada`);
            this.isProcessing = false;
            return;
          }

          const AllFiles: File[] = [];

          this.files.forEach((f1) => AllFiles.push(f1));
          this.filesAntesAdicionados.forEach((f2) => AllFiles.push(f2));

          this.fechamentoOSService
            .uploadPhotos(AllFiles, this.uploadPhotos)
            .subscribe(
              () => {
                this.toastr.success(response.message);
                this.buscar();
                this.reset();
                c("Close click");
              },
              (err: any) => {
                this.showError(err);
              },
            );
        },
        (err: any) => {
          this.showError(err);
        },
      );

      //   // MovOrdemMaterial em 2º momento
    }
  }

  showmsg() {
    console.log("SHOW MSG");
  }
  getById(osid: number, spvId: number, modalDetalhesSpv: any) {
    if (this.isSearchById) {
      return;
    }

    this.isSearchById = true;

    this.osservice.getOSCompleta(osid, spvId).subscribe(
      (response) => {
        this.previewsPhotos = [];
        this.previewsPhotosAntes = [];
        this.previewPhotoSelecionada = null;
        this.files = [];
        this.filesAntes = [];
        this.filesAntesAdicionados = [];
        this.validacoes.reset();

        this.osCompleta = response;
        console.log(this.osCompleta);

        this.possiveisColaboradoresListaGrid =
          this.osCompleta.possiveisColaboradores;
        this.possiveisMateriaisListaGrid = this.osCompleta.possiveisMateriais;

        if (this.osCompleta.spvCompleto.colaboradores == null) {
          // Prepara para os casos de OS do tipo OSPbm que não tem colaboradores vindo de outros cadastros
          // como o ColaboradoresSPV, no caso das OSSPV, ou ColaboradoresPT, no caso das OSPT
          this.osCompleta.spvCompleto.colaboradores = [];
        }

        this.isLoadingRegistroFotografico = true;
        this.fechamentoOSService
          .getArrayFotosBase64(this.osCompleta.uploadPhotos)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.handleFile(
                [].concat(
                  Util.dataURLtoFile(foto.base64String, foto.arquivoNome),
                ),
                false,
              );
              this.previewsPhotos.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
            this.isLoadingRegistroFotografico = false;
          });

        this.fechamentoOSService
          .getArrayFotosBase64(this.osCompleta.fotosAntes)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.handleFileAntes(
                [].concat(
                  Util.dataURLtoFile(foto.base64String, foto.arquivoNome),
                ),
                false,
              );
              this.previewsPhotosAntes.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
            this.isLoadingRegistroFotografico = false;
          });

        this.modalService.open(modalDetalhesSpv, {
          windowClass: "xlModal",
          backdrop: "static",
        });

        this.isSearchById = false;
      },
      (err: any) => {
        this.toastr.error(
          `Ocorreu um erro no servidor.<br /><br /> ${err.error}`,
        );
        this.isSearchById = false;
      },
    );
  }

  /* *** Trata adição e remoção de Colaboradores   *** */
  openModalColaboradores(modal) {
    this.modalService.open(modal, {
      windowClass: "xlModal", //?
      backdrop: "static",
    });
  }

  selectColaborador(id: number) {
    this.osCompleta.possiveisColaboradores.forEach((f) => {
      if (f.id === id) {
        f.marcado = !f.marcado;
      }
    });
  }

  adicionarColaboradores(id: number) {
    this.osCompleta.possiveisColaboradores.forEach((f) => {
      if (f.marcado) {
        f.marcado = false;

        const newColaborador = { ...f, dataHoraInicio: "", dataHoraFim: "" };
        this.osCompleta.spvCompleto.colaboradores.push(newColaborador);
      }
    });

    // reordena pelo nome os colaboradores após a inserção
    this.osCompleta.spvCompleto.colaboradores.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });
  }

  removerColaborador(i: number) {
    this.osCompleta.spvCompleto.colaboradores.splice(i, 1);

    // reordena pelo nome os funcionário após o retorno
    this.osCompleta.possiveisColaboradores.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });

    // reordena pelo nome os funcionário após o retorno
    this.possiveisColaboradoresListaGrid.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });
  }

  /* *** Trata adição e remoção de Irregularidades   *** */

  openModalIrregularidades(modal) {
    this.modalService.open(modal, {
      windowClass: "xlModal",
      backdrop: "static",
    });
  }

  selectIrregularidade(id: number) {
    this.osCompleta.possiveisIrregularidades.forEach((i) => {
      if (i.id === id) {
        i.marcado = !i.marcado;
      }
    });
  }

  adicionarIrregularidades(id: number) {
    this.osCompleta.possiveisIrregularidades.forEach((i) => {
      if (i.marcado) {
        i.marcado = false;
        this.osCompleta.irregularidades.push(i);
        this.osCompleta.possiveisIrregularidades =
          this.osCompleta.possiveisIrregularidades.filter(
            (i2) => i2.id !== i.id,
          );
      }
    });

    // reordena pelo nome os colaboradores após a inserção
    this.osCompleta.irregularidades.sort((i1, i2) => {
      if (i1.nome < i2.nome) {
        return -1;
      }
      if (i1.nome > i2.nome) {
        return 1;
      }
      return 0;
    });
  }

  removerIrregularidade(i: any) {
    this.osCompleta.possiveisIrregularidades.push(i);
    const irregularidadeId = i.id;
    const osFechamentoId = this.osCompleta.osFechamentoId;

    this.osCompleta.irregularidades = this.osCompleta.irregularidades.filter(
      (i2) => i2.id !== i.id,
    );

    // reordena pelo nome os funcionário após o retorno
    this.osCompleta.possiveisIrregularidades.sort((i1, i2) => {
      if (i1.nome < i2.nome) {
        return -1;
      }
      if (i1.nome > i2.nome) {
        return 1;
      }
      return 0;
    });

    if (osFechamentoId !== undefined) {
      this.fechamentoOSService
        .removerOSFechamentoIrregularidade(irregularidadeId, osFechamentoId)
        .subscribe((response) => { });
    }
  }

  /* *** Trata adição e remoção de Fotos   *** */

  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, {
      windowClass: "zoomPhotoModal",
      backdrop: "static",
    });
  }

  handleFile(files: File[], addPreviewsPhotos: boolean = true) {
    if (files.length === 0) {
      return;
    }

    for (const f of files) {
      if (this.validaArquivo(f)) {
        if (!this.files.some((file) => file.name === f.name)) {
          this.files.push(f);

          if (addPreviewsPhotos) {
            this.isLoadingRegistroFotografico = true;
            const reader = new FileReader();
            reader.onload = (event: any) => {
              this.previewsPhotos.push({
                dataUrl: event.target.result,
                name: f.name,
              });
              this.isLoadingRegistroFotografico = false;
            };
            reader.readAsDataURL(f);
          }
        }
      }
    }

    this.photoForm.get("photo").setValue("");
  }

  handleFileFotoAntes(files: File[], addPreviewsPhotos: boolean = true) {
    if (files.length === 0) {
      return;
    }

    for (const f of files) {
      if (this.validaArquivo(f)) {
        if (!this.filesAntes.some((file) => file.name === f.name)) {
          this.filesAntes.push(f);
          this.filesAntesAdicionados.push(f);

          if (addPreviewsPhotos) {
            this.isLoadingRegistroFotografico = true;
            const reader = new FileReader();
            reader.onload = (event: any) => {
              this.previewsPhotosAntes.push({
                dataUrl: event.target.result,
                name: f.name,
              });
              this.isLoadingRegistroFotografico = false;
            };
            reader.readAsDataURL(f);
          }
        }
      }
    }

    this.photoForm.get("photoAntes").setValue("");
  }

  validaArquivo(f: File) {
    let msgErroArquivo = "";
    let arquivoValido = true;
    var pattern = /image-*/;

    if (!f.type.match(pattern)) {
      arquivoValido = false;
      msgErroArquivo += `${f.name} - [${f.type}] <br />`;
      msgErroArquivo += "Não é um arquivo de imagem e não foi adicionado";
    }

    if (arquivoValido) {
      if (f.name.length > 100) {
        arquivoValido = false;
        msgErroArquivo += `${f.name} - [${f.name.length} caracteres] <br />`;
        msgErroArquivo = `O nome do arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir é muito longo e não foi adicionado`;
      }
    }

    if (arquivoValido) {
      const tamanhoArquivo = Number((f.size / 1024 / 1024).toFixed(2));

      if (tamanhoArquivo > APP_SETTINGS.tamanhoLimiteUploadArquivo) {
        arquivoValido = false;
        msgErroArquivo += `${f.name}  [${tamanhoArquivo}MB] <br />`;
        msgErroArquivo = `O arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir ultrapassa o limite de `;
        msgErroArquivo += `<span class="fb">${APP_SETTINGS.tamanhoLimiteUploadArquivo} MB</span> permito para uploads e não foi adicionado.`;
      }
    }

    if (!arquivoValido) {
      Swal({
        position: "center",
        html: msgErroArquivo,
        type: null,
        animation: false,
        customClass: "animated fadeInDown",
        width: "550px",
        heightAuto: false,
        background: "#f7b924",
        showCloseButton: true,
        showConfirmButton: false,
      });
    }

    return arquivoValido;
  }

  handleFileAntes(files: File[], addPreviewsPhotos: boolean = true) {
    ImagemUtil.handleFile(
      files,
      this.filesAntes,
      this.previewsPhotosAntes,
      this.isLoadingRegistroFotografico,
      addPreviewsPhotos,
    );
  }

  removerPhoto(name: string) {
    this.previewsPhotos = this.previewsPhotos.filter(
      (photo: Photo) => photo.name !== name,
    );
    this.files = this.files.filter((f) => f.name !== name);
  }

  removerPhotoAntes(name: string) {
    const photoAdicionada = this.filesAntesAdicionados.find(
      (t) => t.name === name,
    );

    if (photoAdicionada != undefined) {
      this.previewsPhotosAntes = this.previewsPhotosAntes.filter(
        (photo: Photo) => photo.name !== name,
      );
      this.filesAntes = this.filesAntes.filter((f) => f.name !== name);
      this.filesAntesAdicionados = this.filesAntesAdicionados.filter(
        (f) => f.name !== name,
      );
    } else {
      let fotoAntes: any = this.osCompleta.fotosAntes.find(
        (fa) => fa.arquivoNomeOriginal === name,
      );

      if (fotoAntes != undefined) {
        this.removerPhotoPersistida(name, fotoAntes.id);
      }
    }
  }

  public removerPhotoPersistida(name: string, uploadPhotoId: number) {
    Swal({
      title: "Excluir",
      text: "Deseja remover o registro fotográfico selecionado?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: "Não",
      showConfirmButton: true,
      confirmButtonText: "Sim",
      cancelButtonColor: "#d33",
      focusCancel: true,
    }).then((result) => {
      if (result.value) {
        this.delete(name, uploadPhotoId);
      }
    });
  }

  private delete(name: string, uploadPhotoId: number): void {
    this.isRemoveProcessing = true;

    this.osService.removerUploadPhoto(uploadPhotoId).subscribe(
      (response: CommandResult) => {
        const cmdResult = new CommandResult(
          response.success,
          response.message,
          response.notifications,
          response.data,
        );

        if (cmdResult.success === true) {
          this.toastr.success(cmdResult.message);
          this.previewsPhotosAntes = this.previewsPhotosAntes.filter(
            (photo: Photo) => photo.name !== name,
          );
          this.filesAntes = this.filesAntes.filter((f) => f.name !== name);
          this.filesAntesAdicionados = this.filesAntesAdicionados.filter(
            (f) => f.name !== name,
          );
        } else {
          this.toastr.warning(cmdResult.message);
        }

        this.isRemoveProcessing = false;
      },
      (exception: any) => {
        const cmdResult = new CommandResult(false, "", [], null);
        cmdResult.showErrorExecption(exception);
        this.isRemoveProcessing = false;
      },

      () => (this.isRemoveProcessing = false),
    );
  }

  /* *** Trata adição e remoção de Materiais   *** */

  openModalMateriais(modal) {
    this.modalService.open(modal, {
      windowClass: "xlModal",
      backdrop: "static",
    });
  }

  selectMateriais(materialId: number) {
    this.osCompleta.possiveisMateriais.forEach((i) => {
      if (i.materialId === materialId) {
        i.marcado = !i.marcado;
      }
    });
  }

  changeQuantidade(materialId: number, qtde: number) {
    let pmlg = this.possiveisMateriaisListaGrid.find(
      (x) => x.materialId == materialId,
    );
    pmlg.quantidade = qtde;
    pmlg.marcado = true;

    let pm = this.osCompleta.possiveisMateriais.find(
      (x) => x.materialId == materialId,
    );
    pm.quantidade = qtde;
    pm.marcado = true;

    //console.log('!!: ', this.osCompleta.possiveisMateriais.filter(x => x.marcado == true));
  }

  addMaterial(index: number, materialId: number) {
    //console.warn(index);

    if (this.possiveisMateriaisListaGrid.length - 1 >= index + 1) {
      const materialIdNext =
        this.possiveisMateriaisListaGrid[index + 1].materialId;

      (<HTMLInputElement>(
        document.getElementById(String(materialIdNext))
      )).focus();
    }

    this.adicionarMateriais();
  }

  adicionarMateriais() {
    let totalMarcados = 0;
    this.osCompleta.possiveisMateriais.forEach((i) => {
      if (i.marcado) {
        //console.log(i);
        totalMarcados++;
        // const quantidade = <HTMLInputElement>(document.getElementById(i.materialId));

        if (!i.quantidade) {
          i.touched = true;
          return;
        }

        i.marcado = false;
        i.touched = false;
        i.quantidade = i.quantidade;
        this.osCompleta.materiaisUsado.push(i);

        this.osCompleta.possiveisMateriais =
          this.osCompleta.possiveisMateriais.filter(
            (i2) => i2.materialId !== i.materialId,
          );
        this.possiveisMateriaisListaGrid =
          this.possiveisMateriaisListaGrid.filter(
            (i2) => i2.materialId !== i.materialId,
          );
      }
    });

    if (totalMarcados > 0) {
      // reordena pelo nome os materiais após a inserção
      /*  this.osCompleta.materiaisUsado.sort((i1, i2) => {
        if (i1.descricao < i2.descricao) {
          return -1;
        }
        if (i1.descricao > i2.descricao) {
          return 1;
        }
        return 0;
      }); */
    } else {
      this.toastr.warning(
        "Selecione ao menos um material na grid 'Materiais disponíveis'",
      );
    }
  }

  removerMateriais(i: any) {
    i.marcado = false;
    i.touched = false;
    i.quantidade = null;

    this.osCompleta.possiveisMateriais.push(i);
    //this.possiveisMateriaisListaGrid.push(i);
    const materiaisId = i.materialId;
    const osFechamentoId = this.osCompleta.osFechamentoId;

    this.osCompleta.materiaisUsado = this.osCompleta.materiaisUsado.filter(
      (i2) => i2.materialId !== i.materialId,
    );

    this.possiveisMateriaisListaGrid.push(
      this.osCompleta.possiveisMateriais.find(
        (x) => x.materiaisId == materiaisId,
      ),
    );

    // reordena pelo nome os materiais após o retorno
    this.osCompleta.possiveisMateriais.sort((i1, i2) => {
      if (i1.descricao < i2.descricao) {
        return -1;
      }
      if (i1.descricao > i2.descricao) {
        return 1;
      }
      return 0;
    });

    // reordena pelo nome os funcionário após o retorno
    this.possiveisMateriaisListaGrid.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });

    if (osFechamentoId) {
      this.fechamentoOSService
        .removerOSFechamentoMovOrdemMaterial(materiaisId, osFechamentoId)
        .subscribe((response) => { });
    }
  }

  limparDataListFuncionarios() {
    (
      document.getElementById("datalistFuncionarios") as HTMLInputElement
    ).value = "";
    this.possiveisColaboradoresListaGrid =
      this.osCompleta.possiveisColaboradores;
  }

  changeDataListFuncionarios(value: string) {
    if (value != "") {
      this.possiveisColaboradoresListaGrid =
        this.osCompleta.possiveisColaboradores.filter(
          (t) =>
            t.nome.toLowerCase().includes(value.toLowerCase()) ||
            t.matricula.toLowerCase().includes(value.toLocaleLowerCase()),
        );
    }
  }

  limparDataListMateriais() {
    (document.getElementById("datalistMateriais") as HTMLInputElement).value =
      "";

    let pm = [].concat(this.osCompleta.possiveisMateriais);

    if (this.osCompleta.materiaisUsado.length > 0) {
      this.osCompleta.materiaisUsado.forEach((x) => {
        pm = pm.filter((t) => t.materialId != x.materialId);
      });
    }

    this.possiveisMateriaisListaGrid = pm;
  }

  changeDataListMateriais(value: string) {
    if (value != "") {
      this.possiveisMateriaisListaGrid =
        this.osCompleta.possiveisMateriais.filter(
          (t) =>
            t.descricao.toLowerCase().includes(value.toLowerCase()) ||
            t.codigo.toLowerCase().includes(value.toLocaleLowerCase()) ||
            t.tipoMaterialDescricao
              .toLowerCase()
              .includes(value.toLocaleLowerCase()),
        );
    }
  }

  public showError(error: any) {
    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error("Ocorreu um erro no servidor");
    }

    this.isProcessing = false;
  }

  /*   public checkDatasColaboradores() {
      let valid = true;
  
      console.log(this.osCompleta.spvCompleto.colaboradores);
  
      this.osCompleta.spvCompleto.colaboradores.forEach((c) => {
        valid = valid && !!c.dataHoraInicio;
        valid = valid && !!c.dataHoraFim;
      });
  
      return valid;
    } */

  public confirmarColaboradores(c: any) {
    let valid = true;

    let i = 0;

    this.osCompleta.spvCompleto.colaboradores.forEach((c) => {
      const inputdhInicio = <HTMLInputElement>(
        document.getElementById("data-hi-colaborador" + i)
      );
      const inputdhFinal = <HTMLInputElement>(
        document.getElementById("data-hf-colaborador" + i)
      );

      inputdhInicio.classList.remove("h-error");
      inputdhFinal.classList.remove("h-error");

      if (inputdhInicio.parentNode.parentNode.childNodes.item(1)) {
        inputdhInicio.parentNode.parentNode.childNodes.item(1).remove();
      }

      if (inputdhFinal.parentNode.parentNode.childNodes.item(1)) {
        inputdhFinal.parentNode.parentNode.childNodes.item(1).remove();
      }

      const dhInicio = inputdhInicio.value;
      const dhFinal = inputdhFinal.value;

      const NENHUMA_DATA_INFORMADA: boolean = !dhInicio && !dhFinal;
      const ALGUMA_DATA_INFORMADA: boolean = !NENHUMA_DATA_INFORMADA;

      if (ALGUMA_DATA_INFORMADA) {
        const AMBAS_DATAS_INFORMADAS = dhInicio && dhFinal;

        if (AMBAS_DATAS_INFORMADAS) {
          const dataInicio = new Date(dhInicio);
          const dataFim = new Date(dhFinal);

          if (dataFim.getTime() < dataInicio.getTime()) {
            let span = document.createElement("span");
            span.classList.add("txt-danger-fb");
            span.innerHTML =
              "Data/Hora final deve ser maior que Data/Hora inicial";
            inputdhFinal.classList.add("h-error");
            (<HTMLElement>inputdhFinal.parentNode).insertAdjacentElement(
              "afterend",
              span,
            );
            valid = false;
          } else {
            c.dataHoraInicio = dhInicio;
            c.dataHoraFim = dhFinal;
          }
        } else {
          if (!dhInicio) {
            let span = document.createElement("span");
            span.classList.add("txt-danger-fb");
            span.innerHTML = "informe a data/hora início";
            inputdhInicio.classList.add("h-error");
            (<HTMLElement>inputdhInicio.parentNode).insertAdjacentElement(
              "afterend",
              span,
            );
            valid = false;
          }

          if (!dhFinal) {
            let span = document.createElement("span");
            span.classList.add("txt-danger-fb");
            span.innerHTML = "informe a data/hora final";
            inputdhFinal.classList.add("h-error");
            (<HTMLElement>inputdhFinal.parentNode).insertAdjacentElement(
              "afterend",
              span,
            );

            valid = false;
          }
        }
      } else {
        c.dataHoraInicio = "";
        c.dataHoraFim = "";
      }

      i++;
    });

    if (valid) {
      this.validacoes.datasColaboradoresOK = true;
      c("Close click");
    }
  }

  clearInputDataHiColaborador(prefixoIdDataColaborador, i) {
    const inputdata = <HTMLInputElement>(
      document.getElementById(prefixoIdDataColaborador + i)
    );

    inputdata.value = "";
  }

  setShowModalLogAvaliacao() {
    this.showModalLogAvaliacao = true;
  }

  changeShowModal() {
    this.showModalLogAvaliacao = false;
  }
}
